<div class="customer-view-container">
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>
  <div class="driver-view" *ngIf="customerProfile">
    <div class="heading">
      <h3>Basic Information</h3>
    </div>
    <mat-divider></mat-divider>
    <form action="" class="trips-popups">
      <div class="row ml-0 mr-0">
        <div class="col-md-9">
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Name:</div>
              <h6>{{ customerData?.username }}</h6>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Reg.Mobile:</div>
              <h6>{{ customerData?.mobile }}</h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">DOB:</div>
              <h6>{{ customerData?.userInfo[0].dob | date : "dd-MM-yyyy" }}</h6>
            </div>
            <div class="col-md-6">
              <div class="serial-no">Company Name:</div>
              <h6>{{ customerData?.userInfo[0].company_name }}</h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Reg.Date:</div>
              <h6>
                {{ customerData?.userInfo[0]?.createdAt | date : "dd-MM-yyyy" }}
              </h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Reg.Email:</div>
              <h6>{{ customerData?.email }}</h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Designation:</div>
              <h6>{{ customerData?.userInfo[0]?.designation }}</h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Gender:</div>
              <h6>{{ customerData.userInfo[0]?.gender }}</h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Last Login:</div>
              <h6>
                {{ customerData?.last_login | date : "dd-MM-yyyy" }}
                <!-- ,<span>{{
                customerData.last_login | date : "HH:mm:ss"
              }}</span> -->
              </h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6" *ngIf="customerData?.user_type === 'corporate'">
              <div class="serial-no">S9 Margin:</div>
              <h6>{{ customerData?.userInfo[0]?.s9_margin }}</h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6" *ngIf="customerData?.user_type === 'corporate'">
              <div class="serial-no">S9 Workorder Bidding Timer:</div>
              <h6>{{ customerData?.userInfo[0]?.s9_workorder_bidding_timer ? customerData?.userInfo[0]?.s9_workorder_bidding_timer + ' Mins' : 'Default' }}</h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6" *ngIf="customerData?.user_type === 'corporate'">
              <div class="serial-no">Bid Visibility:</div>
              <h6>{{ customerData?.userInfo[0]?.bid_visibility ? 'Yes' : 'No' }}</h6>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="right-side image">
            <img src="{{ customerData?.userInfo[0]?.profile_pic }}" class="driverImg" />
          </div>
        </div>
      </div>
      <div class="row mt-3 ml-0 mr-0">
        <div class="heading mt-3">
          <h3>Billing Address</h3>
        </div>
        <mat-divider></mat-divider>
        <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-3">
            <div class="serial-no">Address Line 1:</div>
            <h6>
              {{ customerData?.userInfo[0]?.billing_address?.address_line }}
            </h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">Landmark:</div>
            <h6>{{ customerData?.userInfo[0]?.billing_address?.landmark }}</h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">City:</div>
            <h6>{{ customerData?.userInfo[0]?.billing_address?.city }}</h6>
          </div>
        </div>
        <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-3">
            <div class="serial-no">State:</div>
            <h6>{{ customerData?.userInfo[0]?.billing_address?.state }}</h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">Pincode:</div>
            <h6>{{ customerData?.userInfo[0]?.billing_address?.pincode }}</h6>
          </div>
        </div>
        <!-- <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-3">
            <div class="serial-no">PAN:</div>
            <h6>{{ customerData?.userInfo[0]?.billing_address?.state }}</h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">TAN:</div>
            <h6>{{ customerData?.userInfo[0]?.billing_address?.pincode }}</h6>
          </div>
        </div> -->

        <div class="row ml-0 mr-0">
          <div class="fixed-btn">
            <button type="button" class="button delete-btn" [class.spinner]="loading" [disabled]="loading"
              (click)="archiveCustomer()">
              Delete Customer
            </button>
            <button type="button" [class.spinner]="loading" [disabled]="loading" (click)="editUserCustomer()"
              class="button">
              Edit
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- ------------------------- Customer Edit -------------------- -->

  <div *ngIf="editCustomerProfile" class="driver-view">
    <div class="heading">
      <h3>Basic Information</h3>
    </div>
    <mat-divider></mat-divider>
    <form [formGroup]="editCustomerFrom" class="admin-forms mt-3 trips-popups">
      <div class="row input-fileds-container ml-0 mr-0">
        <div class="col-xl-9 col-lg-9 col-md-9 adminUser_input">
          <div class="row ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <mat-form-field>
                <div class="serial-no">Name</div>
                <input matInput formControlName="username" required />
              </mat-form-field>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 d-flex align-items-center">
              <div *ngIf="!otpVerify" class="d-flex align-items-center w-100">
                <mat-form-field class="flex-grow-1">
                  <div class="serial-no">Mobile No.</div>
                  <input id="name" class="ex2" appTwoDigitDecimaNumber formControlName="mobile" matInput minlength="10"
                    maxlength="10" required [readonly]="ismobileVerified" (input)="onMobileInputChange()" />
                  <mat-error>Please enter valid mobile number</mat-error>
                </mat-form-field>

                <div *ngIf="mobileVerified === 0" class="d-flex align-items-center">
                  <img class="verify_otp" src="../../../assets/img/error.svg" style="margin-left: 10px" />
                  <a class="otp" (click)="Otpsend()">Send OTP</a>
                </div>
                <div class="otp-field" *ngIf="mobileVerified > 0">
                  <img src="../../../assets/img/tick-verify.svg" style="margin-left: 10px" />
                </div>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12" *ngIf="otpVerify">
              <div class="group otp-field"></div>

              <div class="otp-field" *ngIf="truckowner_verify_otp">
                <img src="../../../assets/img/tick-verify.svg" />
              </div>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <mat-form-field class="mtb d-flex align-items-center">
                <div class="serial-no">DOB:</div>
                <input matInput [matDatepicker]="picker1" [max]="minDob" formControlName="dob"
                  (change)="onDateChnage(2)" required ng-pattern="/^(?:1[8-9]|[2-5][0-9]|60)$/" />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <mat-form-field>
                <div class="serial-no">Company Name:</div>
                <input matInput formControlName="company_name" required />
              </mat-form-field>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Reg.Date:</div>
              <h6>
                {{
                customerData?.userInfo[0]?.createdAt | date : "dd-MM-yyyy"
                }}
              </h6>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Reg.Email:</div>
              <input type="email" matInput formControlName="email" />
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Designation:</div>
              <h6>{{ customerData?.userInfo[0]?.designation }}</h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="serial-no">Last Login:</div>
              <h6>
                {{ customerData?.last_login | date : "dd-MM-yyyy" }},
                <span>{{ customerData?.last_login | date : "hh:mm a" }}</span>
              </h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-xl-6 col-lg-6 col-md-6">
              <mat-form-field class="mtb d-flex align-items-center">
                <div class="serial-no me-2">Gender:</div>
                <mat-select formControlName="gender" class="flex-grow-1">
                  <mat-option value="male">Male</mat-option>
                  <mat-option value="female">Female</mat-option>
                  <mat-option value="others">Others</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6" *ngIf="customerData?.user_type === 'corporate'">
              <mat-form-field>
                <div class="serial-no">S9 Margin:</div>
                <input matInput type="number" formControlName="s9_margin" min="0" onwheel="return false;"
                  (keypress)="preventNegative($event)" />
                <mat-error *ngIf="editCustomerFrom.get('s9_margin')?.hasError('required')">
                  S9 Margin is required
                </mat-error>
                <mat-error *ngIf="editCustomerFrom.get('s9_margin')?.hasError('min')">
                  S9 Margin must be 0 or greater
                </mat-error>
              </mat-form-field>
            </div>
            
            <div class="col-xl-6 col-lg-6 col-md-6" *ngIf="customerData?.user_type === 'corporate'">
              <mat-form-field>
                <div class="serial-no">S9 Workorder Bidding Timer (Minutes):</div>
                <input matInput type="number" formControlName="s9_workorder_bidding_timer" min="0" onwheel="return false;"
                  (keypress)="preventNegative($event)"/>
                <mat-hint>0 or empty uses default timer</mat-hint>
                <mat-error *ngIf="editCustomerFrom.get('s9_workorder_bidding_timer')?.hasError('required')">
                  Timer is required
                </mat-error>
                <mat-error *ngIf="editCustomerFrom.get('s9_workorder_bidding_timer')?.hasError('min')">
                  Timer must be 0 or greater
                </mat-error>
              </mat-form-field>
            </div>
            
            <div class="col-xl-6 col-lg-6 col-md-6" *ngIf="customerData?.user_type === 'corporate'">
              <div class="serial-no">Bid Visibility:</div>
              <mat-slide-toggle formControlName="bid_visibility" color="primary">
                Allow
              </mat-slide-toggle>
            </div>
          </div>





          <div class="row mt-3 ml-0 mr-0">
            <div class="heading mt-3">
              <div class="headings">Billing Address</div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">Name</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput formControlName="name" required />
                      <!-- <mat-error>Name is required</mat-error> -->
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">Email</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput formControlName="billing_email" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">Address Line</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput formControlName="address_line" required />
                      <!-- <mat-error>Address is required</mat-error> -->
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">Landmark</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput formControlName="landmark" required />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">Area</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput formControlName="area_name" required />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">City</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput formControlName="city" required />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">state</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput formControlName="state" required />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">Pincode</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput appTwoDigitDecimaNumber formControlName="pincode" minlength="6" maxlength="6"
                        required />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">Contact Number</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput appTwoDigitDecimaNumber formControlName="billing_mobile" required maxlength="10"
                        minlength="10" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mtb ml-0 mr-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center">
                  <div class="head">GST</div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                  <div class="">
                    <mat-form-field>
                      <input matInput appAlphanumericOnly uppercase formControlName="gst" required maxlength="15"
                        minlength="15" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3">
          <div class="right-side image">
            <img src="{{ truckImage }}" class="driverImg" />
            <div class="image-upload-area">
              <button class="mac" (click)="uploadImage.click()">
                Update Profile
              </button>
              <input #uploadImage type="file" (change)="onChange($event)" hidden />
            </div>
          </div>
        </div>
        <div class="row ml-0 mr-0">
          <div class="fixed-btn">
            <button type="button" [class.spinner]="loading" [disabled]="loading" (click)="updateUser()" class="button">
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>